import dayjs from 'dayjs';

// 포인트 도메인 상수
// 백엔드 enum과 값 일치 필수 (PointType / PointSourceType / PointChannel)

// 적립/차감 구분
export const POINT_TYPE = {
  EARN: 'EARN',
  DEDUCT: 'DEDUCT',
};

export const POINT_TYPE_LABELS = {
  EARN: '적립',
  DEDUCT: '차감',
};

// 적립/차감 발생 출처 — 새 적립 유형이 생기면 여기에만 라벨 추가
export const POINT_SOURCE_LABELS = {
  ADMIN: '운영자 지급',
  PURCHASE: '상품 구매',
  PURCHASE_CANCEL: '구매 적립 회수',
  REFUND_RESTORE: '환불 포인트 복구',
  ATTENDANCE: '출석 적립',
  ATTENDANCE_CANCEL: '출석 적립 회수',
  EXPIRE: '유효기간 만료 소멸',
  GRANT_CANCEL: '지급 취소',
  DEDUCT_CANCEL: '차감 취소',
};

// 사용처 (어느 채널에서 발생했는지)
// 사용처 — 어느 채널에서 생긴 내역인지 (CRM 에서 한 모든 작업 vs 회원앱 결제)
export const POINT_CHANNEL_LABELS = {
  ADMIN: 'CRM',
  MEMBER_APP: '회원앱',
};

// 적립 기본값 단위
export const POINT_EARN_TYPE = {
  FIXED: 'FIXED', // 고정 포인트 (예: 100P)
  PERCENT: 'PERCENT', // 결제금액 대비 % 적립
};

export const POINT_EARN_TYPE_OPTIONS = [
  { value: 'PERCENT', label: '%' },
  { value: 'FIXED', label: 'P' },
];

// 적립 그룹에 배정할 결제수단 (백엔드 PaymentMethod enum과 값 일치 필수 — 제로페이 등 신규 수단은 여기에만 추가)
// APP_CARD(앱결제)는 회원앱 결제 적립률을 따로 잡기 위한 값이다. 주문에 저장되는 결제수단은
// CARD 라서 매출 화면에는 영향이 없고, CRM 수기 판매등록 드롭다운에도 노출되지 않는다
// (백엔드 PaymentMethod.manualSelectable() 이 CARD/CASH/TRANSFER 만 허용).
export const PAYMENT_METHODS = [
  { value: 'CARD', label: '카드' },
  { value: 'CASH', label: '현금' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'APP_CARD', label: '앱결제' },
];

// 1회 최대 사용 단위 (백엔드 MAX_USE_TYPE — PERCENT=결제금액 대비 %, FIXED=정액 P)
export const POINT_MAX_USE_TYPE_OPTIONS = [
  { value: 'PERCENT', label: '%' },
  { value: 'FIXED', label: '원' },
];

// 알 수 없는 enum 값이 와도 깨지지 않도록 폴백 라벨 헬퍼
// ADMIN(수동 조정)은 적립/차감에 따라 지급·차감으로 구분해 표기한다
export const getPointSourceLabel = (sourceType, type) => {
  if (sourceType === 'ADMIN' && type === POINT_TYPE.DEDUCT) return '운영자 차감';
  return POINT_SOURCE_LABELS[sourceType] || sourceType || '-';
};
export const getPointChannelLabel = channel => POINT_CHANNEL_LABELS[channel] || channel || '-';

// 포인트 유효기간 — 적립 유형별 규칙 (branch_point_expire_rule)
export const POINT_EXPIRE_SOURCE = {
  PURCHASE: 'PURCHASE', // 구매 적립 (환불복구·앱결제·전자계약·회원권변경도 이 규칙)
  ATTENDANCE: 'ATTENDANCE', // 출석 적립
  ADMIN: 'ADMIN', // 수기·이벤트 지급
};

export const POINT_EXPIRE_SOURCE_LABELS = {
  PURCHASE: '구매 적립',
  ATTENDANCE: '출석 적립',
  ADMIN: '수기·이벤트 지급',
};

// 구매 적립 전용 산정 방식
export const POINT_EXPIRE_MODE = {
  FIXED: 'FIXED', // 적립일 + 고정 기간
  PRODUCT: 'PRODUCT', // 구매 상품 종료일 (없으면 고정 기간 폴백)
};

// 고정 기간 단위 (백엔드 UsagePeriodType 과 동일)
export const POINT_PERIOD_UNIT = {
  DAY: 'DAY',
  MONTH: 'MONTH',
};

/**
 * 만료일(마지막 유효일) 계산 — 백엔드 PointExpirePolicy.addPeriod 와 같은 규칙.
 * 기준일 + 기간 − 1일. 회원권 종료일 관례와 동일 (1주일=7일이면 오늘 포함 7일).
 */
export const computePointExpireDate = (value, unit, baseDate = dayjs()) => {
  const n = Number(value);
  if (!n || n <= 0) return '';
  // dayjs 의 month 가산은 Java plusMonths 처럼 말일을 클램프한다 (1/31 + 1개월 = 2/28)
  const end = unit === POINT_PERIOD_UNIT.MONTH ? dayjs(baseDate).add(n, 'month') : dayjs(baseDate).add(n, 'day');
  return end.subtract(1, 'day').format('YYYY-MM-DD');
};
